import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorType } from '../models/commonModels';
import styles from './InfoElement.module.scss';
import MaterialIcon from './MaterialIcon';
import StandAloneSpinner from './StandAloneSpinner';

type Props = {
    iconName: string;
    infoText: string;
    onClick?: () => void;
    testAttr: string;
    loading?: boolean;
    error?: ErrorType;
};

const InfoElement = ({ iconName, infoText, onClick, testAttr, loading, error }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    const [wasLoading, setWasLoading] = useState(false);

    useEffect(() => {
        if (loading) {
            setWasLoading(true);
        }
    }, [loading]);

    useEffect(() => {
        if (error) {
            setWasLoading(false);
        }
    }, [error]);

    return (
        <div className={styles.linkWrapper} {...{ [`data-${testAttr}`]: true }}>
            {loading ? (
                <StandAloneSpinner />
            ) : (
                <MaterialIcon
                    name={wasLoading ? 'check_circle_outline' : iconName}
                    extraClass={wasLoading ? styles.greenIcon : undefined}
                />
            )}
            {onClick ? (
                <button type="button" className={styles.button} onClick={onClick}>
                    {txt(infoText)}
                </button>
            ) : (
                <span>{infoText}</span>
            )}
        </div>
    );
};

export default InfoElement;
